const utils = {};

utils.install = (Vue) => {
  Vue.mixin({
    // 自定义全局data
    data: () => ({
    }),
    // 自定义方法
    method: {
      // 获取地址栏相应参数
      getUrlParam(name) {
        const after = window.location.search.split('?')[1];
        if (after) {
          const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); // eslint-disable-line
          const r = after.match(reg);
          if (r != null) return decodeURIComponent(r[2]);
        }
        return null;
      },
    },
    // 自定义指令
    directives: {
      // 页面刷新后就自动获取焦点，给input元素添加v-focus属性
      focus: {
        inserted: (el) => {
          el.focus();
        },
      },
    },
    // 自定义filter
    filters: {

    },
  });
};

export default utils;



// WEBPACK FOOTER //
// ./src/utils/index.js